if (!customElements.get('sticky-add-to-cart')) {
  class StickyAddToCart extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.submitButton = this.querySelector('[data-sticky-submit]');
      this.submitLabel = this.querySelector('[data-sticky-submit-label]');
      this.priceEl = this.querySelector('[data-sticky-price]');

      const productInfo = document.getElementById(`MainProduct-${this.sectionId}`);
      if (!productInfo) return; 

      this.mainSubmit = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      this.priceContainer = productInfo.querySelector(`#price-${this.sectionId}`);

      this._syncSubmitState();
      this._syncPrice();
      this._offsetForPreviewBar();
      this._watchTrigger();
    }

    // Shopify's theme preview bar is fixed to the viewport bottom and covers
    // this bar while previewing an unpublished theme. Offset above it.
    _offsetForPreviewBar() {
      const apply = () => {
        const bar = document.getElementById('PBarNextFrameWrapper');
        const offset = bar ? bar.getBoundingClientRect().height : 0;
        this.style.bottom = offset > 0 ? `${offset}px` : '';
      };

      apply();

      const watchBar = (bar) => {
        new MutationObserver(apply).observe(bar, {
          attributes: true,
          attributeFilter: ['style', 'class'],
        });
      };

      const existing = document.getElementById('PBarNextFrameWrapper');
      if (existing) {
        watchBar(existing);
      } else {
        // Injected asynchronously by Shopify's preview script
        const bodyObserver = new MutationObserver(() => {
          const bar = document.getElementById('PBarNextFrameWrapper');
          if (bar) {
            bodyObserver.disconnect();
            watchBar(bar);
            apply();
          }
        });
        bodyObserver.observe(document.body, { childList: true });
      }

      window.addEventListener('resize', apply);
    }

    _syncSubmitState() {
      if (!this.mainSubmit || !this.submitButton) return;

      const apply = () => {
        this.submitButton.disabled = this.mainSubmit.disabled;
        const label = this.mainSubmit.querySelector('span');
        if (label && this.submitLabel) {
          this.submitLabel.textContent = label.textContent;
        }
      };

      apply();
      new MutationObserver(apply).observe(this.mainSubmit, {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    _syncPrice() {
      if (!this.priceContainer || !this.priceEl) return;

      const apply = () => {
        const priceNode =
          this.priceContainer.querySelector('.price-item--sale') ||
          this.priceContainer.querySelector('.price-item--regular') ||
          this.priceContainer.querySelector('.price-item');
        if (priceNode) this.priceEl.textContent = priceNode.textContent.trim();
      };

      apply();
      new MutationObserver(apply).observe(this.priceContainer, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    _watchTrigger() {
      if (!this.mainSubmit) return;

      this._updateVisibility();

      let ticking = false;
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          ticking = false;
          this._updateVisibility();
        });
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', () => this._updateVisibility());
    }

    _updateVisibility() {
      if (!this.mainSubmit) return;
      const rect = this.mainSubmit.getBoundingClientRect();
      const passed = rect.bottom < 0;
      this.classList.toggle('is-visible', passed);
      this.setAttribute('aria-hidden', passed ? 'false' : 'true');
    }
  }

  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
